import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SuiTextInput, SuiHelperText } from '@splashthat/sui';
import get from 'lodash/get';

import { getFormNode } from 'common/entities/formNode/selectors';
import { setInitialValue } from '../../../actions';
import disableWhenLocked from './disableWhenLocked';

const DEFAULT_VALUE_LABEL = 'Custom message';
const BASE_COMPONENT_NAME = 'DefaultValueControl';

const DefaultValueControl = ({ initialValue, onChange, disabled }) => (
    <>
        <SuiTextInput
            fullWidth
            label={DEFAULT_VALUE_LABEL}
            defaultValue={initialValue}
            onChange={(event, value) => onChange(value)}
            disabled={disabled}
            data-qa={`${BASE_COMPONENT_NAME}__input`}
        />
        <SuiHelperText text={'Appears in communications wherever this hidden field’s personalization tag is used.'} />
    </>
);

DefaultValueControl.propTypes = {
    initialValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        initialValue: props.formNodeId ? get(formNode, 'config.initialValue', '') : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (initialValue) => dispatch(setInitialValue(ownProps.formNodeId, initialValue)),
});

const ConnectedDefaultValueControl = connect(
    mapStateToProps,
    mapDispatchToProps,
)(disableWhenLocked(DefaultValueControl));

ConnectedDefaultValueControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedDefaultValueControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedDefaultValueControl;
